module.exports = __webpack_public_path__ + "fonts/Inter-Light.37ead45.woff2";